import React, { useEffect, useRef } from "react";
import { Header } from "../components/Common/Header";
import { Title } from "../components/Common/Title";
import { Chart } from "react-google-charts";

import {
  asiadata,
  eurpoe,
  southamerica,
  northamerica,
  africadata,
  ocenia,
} from "../data/Facts/mapdata";

import BgImage from "../assets/images/Headers/Facts.webp";

import Book from "../assets/images/book-in-hands.webp";

export const Facts = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      const container = containerRef.current;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      container.scrollLeft = (scrollWidth - clientWidth) / 2;
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header image={BgImage} title="EMPOWERING THE WORLD THROUGH COACHING." />

      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap", // Enable wrapping on small screens
            gap: "50px", // Add spacing when items wrap
          }}
        >
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
            }}
          >
            <p
              style={{
                fontSize: "40px",
                textAlign: "left",
                lineHeight: "1.2", // Adjust line-height for readability
              }}
              data-aos="fade-up"
            >
              Professional Coaches Membership and Credentialing
            </p>
            <p
              style={{
                fontSize: "16px",
                textAlign: "left",
                lineHeight: "1.6", // Add spacing between lines for readability
              }}
              data-aos="fade-up"
            >
              The International Coaching Federation (ICF) is dedicated to
              advancing the coaching profession by setting high ethical
              standards, providing independent certification, and building a
              worldwide network of credentialed coaches across a variety of
              coaching disciplines. ICF defines coaching as “partnering with
              clients in a thought-provoking and creative process that inspires
              them to maximize their personal and professional potential.”
            </p>
          </div>
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              aspectRatio: "4 / 3",
            }}
            data-aos="fade-up"
          >
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={Book}
              alt="Coaching Federation Logo"
            />
          </div>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <Title subtitle="ICF Membership Growth By Year" />

        <div
          ref={containerRef}
          style={{
            display: "flex",
            overflowX: "scroll",
            overflowY: "hidden",
          }}
          // className="scroll-container"
        >
          <div
            style={{
              marginTop: "50px",
              width: "100%",
              minWidth: "600px",
              aspectRatio: "16/9",
              maxHeight: "calc(100vh - 50px)",
              overflow: "auto",
            }}
          >
            <Chart
              chartType="Bar"
              width="100%"
              height="100%"
              data={[
                ["Year", "Members"],
                ["1999", 2122],
                ["2000", 3240],
                ["2001", 4691],
                ["2002", 5285],
                ["2003", 6791],
                ["2004", 7912],
                ["2005", 9041],
                ["2006", 11100],
                ["2007", 13400],
                ["2008", 15800],
                ["2009", 15949],
                ["2010", 17648],
                ["2011", 19127],
                ["2012", 20222],
                ["2013", 22135],
                ["2014", 24100],
                ["2015", 26476],
                ["2016", 29298],
                ["2017", 30578],
                ["2018", 33739],
                ["2019", 33594],
                ["2020", 39748],
                ["2021", 50748],
                ["2022", 56400],
                ["2023", 58279],
              ]}
              options={{
                series: {
                  0: {
                    color: "#107988",
                  },
                },
              }}
            />
          </div>
        </div>

        <style>
          {`
      .scroll-container::-webkit-scrollbar {
        height: 8px; /* Adjust scrollbar height */
        background-color: transparent; /* Optional: transparent track */
      }

      .scroll-container::-webkit-scrollbar-thumb {
        background-color: #107988; /* Set thumb color to red */
        border-radius: 4px; /* Rounded scrollbar */
      }

      .scroll-container::-webkit-scrollbar-track {
        background-color: #f0f0f0; /* Optional: set track color */
      }
    `}
        </style>
      </div>

      <div
        style={{
          width: "100%",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <Title subtitle="ICF Membership By Region" />
        <div style={{ width: "100%", aspectRatio: "16/9" }}>
          <Chart
            chartType="PieChart"
            data={[
              ["Region", "Percentage"],
              ["Western Europe", 24],
              ["Asia", 9],
              ["Eastern Europe", 5],
              ["North America", 50],
              ["Latin America and the Caribbean", 3],
              ["Middle East and Africa", 5],
              ["Oceania", 4],
            ]}
            options={{
              pieStartAngle: 100,

              colors: [
                "#6CE5E8",
                "#41B8D5",
                "#2D8BBA",
                "#2F5F98",
                "#31356E",
                "#5E3967",
                "#895273",
              ],
            }}
            width={"100%"}
            height={"100%"}
          />
        </div>
      </div>

      <div
        style={{
          width: "100%",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <Title subtitle="ICF Membership By Country" />

        <div style={{ width: "100%", aspectRatio: "16/9", marginTop: "50px" }}>
          <p
            style={{
              fontSize: "16px",
              textAlign: "left",
              lineHeight: "1.6", // Add spacing between lines for readability
              marginBottom: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>Asia :</span> 5599 ICF members
          </p>
          <Chart
            chartType="GeoChart"
            width="100%"
            height="100%"
            data={asiadata}
            options={{
              region: "142",
              displayMode: "regions",
              colorAxis: {
                colors: [
                  "#6CE5E8",
                  "#41B8D5",
                  "#2D8BBA",
                  "#2F5F98",
                  "#31356E",
                ],
              },
            }}
          />
        </div>

        <div style={{ width: "100%", aspectRatio: "16/9", marginTop: "50px" }}>
          <p
            style={{
              fontSize: "16px",
              textAlign: "left",
              lineHeight: "1.6", // Add spacing between lines for readability
              marginBottom: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>Europe :</span> 15,675 ICF
            members
          </p>
          <Chart
            chartType="GeoChart"
            width="100%"
            height="100%"
            data={eurpoe}
            options={{
              region: "150",
              displayMode: "regions",
              colorAxis: {
                colors: [
                  "#6CE5E8",
                  "#41B8D5",
                  "#2D8BBA",
                  "#2F5F98",
                  "#31356E",
                ],
              },
            }}
          />
        </div>

        <div style={{ width: "100%", aspectRatio: "16/9", marginTop: "50px" }}>
          <p
            style={{
              fontSize: "16px",
              textAlign: "left",
              lineHeight: "1.6", // Add spacing between lines for readability
              marginBottom: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>Africa :</span> 1053 ICF
            members
          </p>
          <Chart
            chartType="GeoChart"
            width="100%"
            height="100%"
            data={africadata}
            options={{
              region: "002",
              displayMode: "regions",
              colorAxis: {
                colors: [
                  "#6CE5E8",
                  "#41B8D5",
                  "#2D8BBA",
                  "#2F5F98",
                  "#31356E",
                ],
              },
            }}
          />
        </div>

        <div style={{ width: "100%", aspectRatio: "16/9", marginTop: "50px" }}>
          <p
            style={{
              fontSize: "16px",
              textAlign: "left",
              lineHeight: "1.6", // Add spacing between lines for readability
              marginBottom: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>North America :</span> 30,037
            ICF members
          </p>
          <Chart
            chartType="GeoChart"
            width="100%"
            height="100%"
            data={northamerica}
            options={{
              region: "021",
              // region: "world",
              displayMode: "regions",
              colorAxis: {
                colors: [
                  "#6CE5E8",
                  "#41B8D5",
                  "#2D8BBA",
                  "#2F5F98",
                  "#31356E",
                ],
              },
            }}
          />
        </div>

        <div style={{ width: "100%", aspectRatio: "16/9", marginTop: "50px" }}>
          <p
            style={{
              fontSize: "16px",
              textAlign: "left",
              lineHeight: "1.6", // Add spacing between lines for readability
              marginBottom: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>South America :</span> 1,097
            ICF members
          </p>
          <Chart
            chartType="GeoChart"
            width="100%"
            height="100%"
            data={southamerica}
            options={{
              region: "005",
              displayMode: "regions",
              colorAxis: {
                colors: [
                  "#6CE5E8",
                  "#41B8D5",
                  "#2D8BBA",
                  "#2F5F98",
                  "#31356E",
                ],
              },
            }}
          />
        </div>


        <div style={{ width: "100%", aspectRatio: "16/9", marginTop: "50px" }}>
          <p
            style={{
              fontSize: "16px",
              textAlign: "left",
              lineHeight: "1.6", // Add spacing between lines for readability
              marginBottom: "10px",
            }}
          >
            <span style={{ fontWeight: "bold" }}>Oceania :</span> 2,306
            ICF members
          </p>
          <Chart
            chartType="GeoChart"
            width="100%"
            height="100%"
            data={ocenia}
            options={{
              region: "AU",
              displayMode: "regions",
              colorAxis: {
                colors: [
                  "#6CE5E8",
                  "#41B8D5",
                  "#2D8BBA",
                  "#2F5F98",
                  "#31356E",
                ],
              },
            }}
          />
        </div>

        <p
          style={{
            fontSize: "16px",
            textAlign: "left",
            lineHeight: "1.6", // Add spacing between lines for readability
            marginTop: "50px",
          }}
        >
          As of November 2024 : 59,627 members in 158 countries and territories.
          (This number is subject to frequent change)
        </p>

        {/* <div
          ref={containerRef}
          style={{
            display: "flex",
            overflowX: "scroll",
            overflowY: "hidden",
          }}
         
        > */}
        {/* <div
            style={{
              marginTop: "50px",
              width: "100%",
              minWidth: "600px",
              aspectRatio: "16/9",
              maxHeight: "calc(100vh - 50px)",
              // overflow: "auto",
            }}
          > */}

        {/* </div>
        </div> */}

        <style>
          {`
      .scroll-container::-webkit-scrollbar {
        height: 8px; /* Adjust scrollbar height */
        background-color: transparent; /* Optional: transparent track */
      }

      .scroll-container::-webkit-scrollbar-thumb {
        background-color: #107988; /* Set thumb color to red */
        border-radius: 4px; /* Rounded scrollbar */
      }

      .scroll-container::-webkit-scrollbar-track {
        background-color: #f0f0f0; /* Optional: set track color */
      }
    `}
        </style>
      </div>
    </>
  );
};